import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

// =============================================================
// HIER DIE BILDPFADE ÄNDERN - Speichern → Bild ändert sich sofort
// =============================================================
const PRODUCT_CONFIG = [
  { id: 1, path: '/images/mohrueben.webp', alt: 'Morötter' },
  { id: 2, path: '/images/sauerkraut.webp', alt: 'Mjälksyrad' },
  { id: 3, path: '/images/kaalrot1.webp', alt: 'Mejeriet' },
  { id: 4, path: '/images/Morotsjuice.webp', alt: 'Morotsjuice' },
  { id: 5, path: '/images/buljong.webp', alt: 'Produktion' }
];
// =============================================================

const ProductShowcase = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            {t('productShowcase.currentInStore')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('productShowcase.notOnlyCarrots')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-12">
          {PRODUCT_CONFIG.map((product) => (
            <div
              key={product.id}
              className="rounded-lg overflow-hidden shadow-md hover-scale"
            >
              <img
                src={product.path}
                alt={product.alt}
                className="w-full h-48 object-cover"
              />
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/produkter"
            className="btn-custom-primary px-8 py-3 rounded-lg font-semibold inline-block"
          >
            {t('productShowcase.findMore')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;